import React, { useRef, useState, useEffect } from "react"
import styled from "@emotion/styled"
import { injectIntl } from "gatsby-plugin-intl"
import "flickity/css/flickity.css"
import { isBrowser } from "../../context/ApolloContext"
const Flickity =
  typeof window !== `undefined` ? require("react-flickity-component") : null

const CompositionSectionWrapper = styled.div`
  display: flex;
  background: #1b2a56;
  width: 100%;
  align-items: center;
`

const CompositionSectionContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0px auto;
  display: flex;
  padding: 40px 20px;
  color: #fff;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  padding-left: 50px;

  @media (max-width: 600px) {
    display: none;
  }
`

const MobileImageWrapper = styled.div`
  width: 100%;
  display: none;
  position: relative;
  padding-left: 25px;
  margin-bottom: 30px;

  @media (max-width: 600px) {
    display: flex;
    width: calc(100% + 20px);
  }
`

const Image = styled.img`
  width: 100%;
  margin: 0px;
  object-position: left center;

  @media (max-width: 600px) {
    min-height: 250px;
    object-fit: cover;
  }
`

const LayerCountWrapper = styled.div`
  width: 100%;
  height: 100%;
  max-width: 30%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  left: 0px;

  @media (max-width: 600px) {
    max-width: 50%;
  }

  @media (max-width: 420px) {
    max-width: 55%;
  }
`

const LayerCount = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

const LayerLine = styled.div`
  width: 100%;
  border-top: 1px dashed #fff;
`

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: bold;
  font-family: "BebasNeueBold";
  line-height: 1;
  margin: 0px 0px 20px 0px;
`

const SectionSubTitle = styled.p`
  font-size: 14px;
  font-weight: 500;
  font-family: "GothamLight";
  line-height: 1.2;
  margin: 0px 0px 20px 0px;
`

const CompositionSliderWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`

const Carousel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 360px;
  margin: 10px 0 0 0;
  padding-bottom: 35px;

  @media (max-width: 600px) {
    margin: 0px;
    max-width: 100%;
  }

  .flickity-prev-next-button {
    background-color: transparent;
    color: #111;
    width: 30px;
    height: 30px;
    border: 2px solid #111;

    :hover {
      background-color: #111;
      color: #fff;
    }
  }
  .flickity-prev-next-button.next {
    right: -35px;

    @media (max-width: 600px) {
      right: 15px;
    }
  }
  .flickity-prev-next-button.previous {
    left: -35px;

    @media (max-width: 600px) {
      left: 15px;
    }
  }
  .flickity-page-dots {
    li {
      background: #fff;
    }
  }
`

const TitleWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
`

const TextWrapper = styled.div`
  display: flex;
  align-items: center;
`

const TextImage = styled.img`
  width: 100%;
  margin: 0px 15px 0px 0px;
  max-width: 85px;
  border: 1px solid #fff;
  border-radius: 10px 0px;
`

const LayerWrapper = styled.div`
  display: flex;
`

const LayerBoxWrapper = styled.div`
  width: 100%;
  display: flex;
`

const LayerBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: ${({ order, page }) =>
    order == 1
      ? "12%"
      : order == 2
      ? "19%"
      : order == 3
      ? "27%"
      : order == 4
      ? "37%"
      : order == 5
      ? "50%"
      : order == 6
      ? "69%"
      : "76%"};
`

const OriginalLayerBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: ${({ order, page }) =>
    order == 1
      ? "1%"
      : order == 2
      ? "8%"
      : order == 3
      ? "16%"
      : order == 4
      ? "28%"
      : order == 5
      ? "43%"
      : order == 6
      ? "57%"
      : "73%"};
`

const BoisLayerBox = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: absolute;
  top: ${({ order, page }) =>
    order == 1
      ? "0%"
      : order == 2
      ? "8%"
      : order == 3
      ? "17%"
      : order == 4
      ? "27%"
      : order == 5
      ? "42%"
      : order == 6
      ? "56%"
      : "70%"};
`

const LayerNumber = styled.div`
  background: #fff;
  font-family: "BebasNeueBold";
  font-weight: bold;
  font-size: 13px;
  line-height: 1;
  min-width: 18px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #1b2a56;
  margin: ${({ margin }) => (margin ? "0px 5px 0px 0px" : "0px 2px 0px 10px")};
  opacity: ${({ opacity, activeCell }) =>
    opacity ? "1" : activeCell ? "1" : "0.2"};

  @media (max-width: 600px) {
    margin: ${({ margin }) => (margin ? "0px 5px 0px 0px" : "0px")};
  }
`

const Title = styled.h3`
  font-size: 20px;
  font-weight: 900;
  font-family: "Museo";
  line-height: 1.1;
  margin: 0px 0px 0px 5px;

  @media (max-width: 600px) {
    font-size: 16px;
  }
`

const Text = styled.p`
  font-family: "Gotham Book";
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0px;

  small {
    font-size: 12px;
  }
`

const SommierCompositionSection = ({ intl, data, id, page }) => {
  const [selectNumberBox, setselectNumberBox] = useState(0)
  const [selectSlide, setselectSlide] = useState(0)

  const LayerCounter = [[1, 3, 5, 7], [2, 6], [4]]

  const flickityOptions = {
    freeScroll: false,
    pageDots: true,
    wrapAround: true,
    prevNextButtons: false,
    initialIndex: selectSlide,
  }

  var prevNext = useRef()

  const handleOnClickActive = i => {
    setselectNumberBox(i)
    setselectSlide(i)
  }

  const onHandleChange = e => {
    setselectNumberBox(e)
    setselectSlide(e)
  }

  useEffect(() => {
    prevNext && prevNext.on("change", onHandleChange)
  }, [])

  return (
    data && (
      <CompositionSectionWrapper
        id={id}
        className={id ? "lyneup-page-section" : ""}
      >
        <CompositionSectionContainer>
          {data.list && (
            <CompositionSliderWrapper>
              {data.section_title && (
                <SectionTitle
                  dangerouslySetInnerHTML={{
                    __html: data.section_title,
                  }}
                />
              )}
              {data.section_subtitle && (
                <SectionSubTitle
                  dangerouslySetInnerHTML={{
                    __html: data.section_subtitle,
                  }}
                />
              )}

              {data.image && (
                <MobileImageWrapper>
                  {data.list && (
                    <LayerCountWrapper>
                      {data.list.map((item, index) => {
                        return (
                          item &&
                          item.text && (
                            <LayerCount
                              key={index.toString()}
                              onClick={() => handleOnClickActive(index)}
                            >
                              <LayerBoxWrapper
                                style={{ flexDirection: "column" }}
                              >
                                {LayerCounter[index].map(
                                  (layerItem, layerIndex) => {
                                    return layerItem &&
                                      page === "sommier-original" ? (
                                      <OriginalLayerBox
                                        key={layerIndex.toString()}
                                        order={layerItem}
                                      >
                                        <LayerNumber
                                          activeCell={
                                            selectNumberBox === index
                                              ? true
                                              : false
                                          }
                                        >
                                          {layerItem}
                                        </LayerNumber>
                                        <LayerLine />
                                      </OriginalLayerBox>
                                    ) : layerItem && page === "sommier-bois" ? (
                                      <BoisLayerBox
                                        key={layerIndex.toString()}
                                        order={layerItem}
                                      >
                                        <LayerNumber
                                          activeCell={
                                            selectNumberBox === index
                                              ? true
                                              : false
                                          }
                                        >
                                          {layerItem}
                                        </LayerNumber>
                                        <LayerLine />
                                      </BoisLayerBox>
                                    ) : (
                                      <LayerBox
                                        key={layerIndex.toString()}
                                        order={layerItem}
                                      >
                                        <LayerNumber
                                          activeCell={
                                            selectNumberBox === index
                                              ? true
                                              : false
                                          }
                                        >
                                          {layerItem}
                                        </LayerNumber>
                                        <LayerLine />
                                      </LayerBox>
                                    )
                                  }
                                )}
                              </LayerBoxWrapper>
                            </LayerCount>
                          )
                        )
                      })}
                    </LayerCountWrapper>
                  )}
                  <Image
                    className="lazyload"
                    data-src={data.image}
                    alt={data.alt ? data.alt : ""}
                  />
                </MobileImageWrapper>
              )}
              {isBrowser && (
                <Carousel>
                  <div style={{ width: "100%" }}>
                    <Flickity
                      flickityRef={c => (prevNext = c)}
                      options={flickityOptions}
                      className={"carousel"}
                      reloadOnUpdate
                    >
                      {data.list.map((item, index) => {
                        return (
                          item &&
                          item.text && (
                            <Card key={index.toString()}>
                              <TitleWrapper>
                                <LayerWrapper>
                                  {LayerCounter[index].map(
                                    (layerItem, layerIndex) => {
                                      return (
                                        layerItem && (
                                          <LayerNumber
                                            key={layerIndex.toString()}
                                            margin="2px"
                                            opacity="1"
                                          >
                                            {layerItem}
                                          </LayerNumber>
                                        )
                                      )
                                    }
                                  )}
                                </LayerWrapper>
                                <Title
                                  dangerouslySetInnerHTML={{
                                    __html: item.title,
                                  }}
                                />
                              </TitleWrapper>
                              <TextWrapper>
                                <TextImage
                                  className="lazyload"
                                  data-src={item.image}
                                  alt={item.alt ? item.alt : ""}
                                />
                                <Text
                                  dangerouslySetInnerHTML={{
                                    __html: item.text,
                                  }}
                                />
                              </TextWrapper>
                            </Card>
                          )
                        )
                      })}
                    </Flickity>
                  </div>
                </Carousel>
              )}
            </CompositionSliderWrapper>
          )}
          {data.image && (
            <ImageWrapper>
              {data.list && (
                <LayerCountWrapper>
                  {data.list.map((item, index) => {
                    return (
                      item &&
                      item.text && (
                        <LayerCount
                          key={index.toString()}
                          onClick={() => handleOnClickActive(index)}
                        >
                          <LayerBoxWrapper style={{ flexDirection: "column" }}>
                            {LayerCounter[index].map(
                              (layerItem, layerIndex) => {
                                return layerItem &&
                                  page === "sommier-original" ? (
                                  <OriginalLayerBox
                                    key={layerIndex.toString()}
                                    order={layerItem}
                                  >
                                    <LayerNumber
                                      activeCell={
                                        selectNumberBox === index ? true : false
                                      }
                                    >
                                      {layerItem}
                                    </LayerNumber>
                                    <LayerLine />
                                  </OriginalLayerBox>
                                ) : layerItem && page === "sommier-bois" ? (
                                  <BoisLayerBox
                                    key={layerIndex.toString()}
                                    order={layerItem}
                                  >
                                    <LayerNumber
                                      activeCell={
                                        selectNumberBox === index ? true : false
                                      }
                                    >
                                      {layerItem}
                                    </LayerNumber>
                                    <LayerLine />
                                  </BoisLayerBox>
                                ) : (
                                  <LayerBox
                                    key={layerIndex.toString()}
                                    order={layerItem}
                                  >
                                    <LayerNumber
                                      activeCell={
                                        selectNumberBox === index ? true : false
                                      }
                                    >
                                      {layerItem}
                                    </LayerNumber>
                                    <LayerLine />
                                  </LayerBox>
                                )
                              }
                            )}
                          </LayerBoxWrapper>
                        </LayerCount>
                      )
                    )
                  })}
                </LayerCountWrapper>
              )}
              <Image
                className="lazyload"
                data-src={data.image}
                alt={data.alt ? data.alt : ""}
              />
            </ImageWrapper>
          )}
        </CompositionSectionContainer>
      </CompositionSectionWrapper>
    )
  )
}

export default injectIntl(SommierCompositionSection)
